import React from 'react';
import PropTypes from 'prop-types';
import PointOfInterestTypeIcon, { hasIcon } from 'components/field/PointOfInterestTypeIcon';
import styled from 'styled-components';

const PointOfInterestResultWrapper = styled.div`
    padding-top: 5px;
`;

const IconWrapper = styled.div`
    float: left;
    height: 40px;
    width: 40px;
    margin-right: 10px;
`;

const NameWrapper = styled.div`
    position: relative;
    float: left;
`;

const SubTitle = styled.div`
    position: absolute;
    left: 0;
    font-size: 12px;
    color: grey;
    line-height: 20px;
`;

const Title = styled.div`
    position: absolute;
    top: 18px;
    left: 0;
    font-size: 16px;
    line-height: 20px;
`;

const PointOfInterestResult = (props) => {
    const { result } = props;

    return (
        <PointOfInterestResultWrapper>
            { hasIcon(result.type) &&
                <IconWrapper>
                    <PointOfInterestTypeIcon type={ result.type } />
                </IconWrapper>
            }

            <NameWrapper>
                <SubTitle>{ result.type }</SubTitle>
                <Title>{ result.text }</Title>
            </NameWrapper>
        </PointOfInterestResultWrapper>
    );
};

PointOfInterestResult.propTypes = {
    result: PropTypes.object,
};

export default PointOfInterestResult;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/LocationInputField/PointOfInterestResult.js